import React from "react"
// import { NavLink } from "react-router-dom"
import OwlCarousel from "react-owl-carousel"
import "owl.carousel/dist/assets/owl.carousel.css"
import "owl.carousel/dist/assets/owl.theme.default.css"


const projects = [
  {
    image: require("./../../images/projects/square/pic1.jpg"),
    title: "Concrete Retaining Jack",
    description: "",
    //   "We provide a range of architectural 3D modeling services to our customers to aid the design",
  },
  {
    image: require("./../../images/projects/square/pic2.jpg"),
    title: "Green Framework",
    description: "",
    //   "Analysis and planning services that help both the client and architects to work out the forthcoming project...",
  },
  {
    image: require("./../../images/projects/square/pic3.jpg"),
    title: "Doka Framework",
    description: "",
    //   "We offer comprehensive Architectural Engineering Services including Interior design, Master planning.",
  },
  {
    image: require("./../../images/projects/square/pic4.jpg"),
    title: "Wood",
    description: "",
  },
  
  {
    image: require("./../../images/projects/square/pic5.jpg"),
    title: "Plastic Spacer",
    description:
      "We combine Interior and Exterior Design services and often provide them as a single solution. It helps us...",
  },
  {
    image: require("./../../images/projects/square/pic6.jpg"),
    title: "Living Room",
    description:
      "We combine Interior and Exterior Design services and often provide them as a single solution. It helps us...",
  },
   {
    image: require("./../../images/projects/square/pic7.jpg"),
    title: "Concrete Formwork",
    description:
      "We combine Interior and Exterior Design services and often provide them as a single solution. It helps us...",
  },
]

var bgimg1 = require("./../../images/background/cross-line2.png")

class Services3 extends React.Component {
  render() {
    const options = {
      loop: true,
      autoplay: false,
      center: false,
      margin: 10,
      nav: true,
      dots: false,
      navText: [
        '<i class="fa fa-angle-left"></i>',
        '<i class="fa fa-angle-right"></i>',
      ],
      responsive: {
        0: {
          items: 1,
        },
        640: {
          items: 2,
        },
        768: {
          items: 2,
        },
        991: {
          items: 3,
        },
        1200: {
          items: 5,
        },
      },
    }
    return (
      <>
        <div className="section-full mobile-page-padding p-t30 bg-white bg-change-section">
          <div className="container">
            {/* TITLE START */}
            <div className="section-head">
              <div className="sx-separator-outer separator-center">
                <div
                  className="sx-separator bg-white bg-moving bg-repeat-x"
                  style={{ backgroundImage: "url(" + bgimg1 + ")" }}
                >
                  <h3 className="sep-line-one">Product Types</h3>
                </div>
              </div>
            </div>
            {/* TITLE END */}
          </div>
         

          <OwlCarousel
            className="owl-carousel service-slider-two owl-btn-vertical-center"
            {...options}
          >
            {projects.map((item, index) => (
              <div className="item" key={index}>
                <div
                  className="bgcall-block d-flex flex-wrap justify-content-center align-content-end bg-cover overlay-wraper"
                  style={{ backgroundImage: "url(" + item.image + ")" }}
                >
                  
                  <div className="overlay-main  opacity-05" />
                  <div className="bg-content-mid-outer">
                    <div className="bg-content-mid">
                      <div className="sx-icon-box-wraper center text-white">
                        <div className="icon-lg m-b15">
                          <span className="icon-cell">
                            <i className={item.flaticon} />
                          </span>
                        </div>
                        <div className="icon-content">
                          <h4 className="sx-tilte">
                            {" "}
                            
                              {" "}
                              {item.title}
                            
                          </h4>
                        </div>
                      </div>
                     
                      <div className="bg-overlay" />
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </OwlCarousel>
        </div>
      </>
    )
  }
}

export default Services3
